import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Rev from './assets/Rev.jfif'
import Bin from './assets/Binary.jpg'
import Algo from './assets/algo.jfif'
import Mis from './assets/mis.jfif'
import Maj from './assets/maj.png'
import Search from './assets/srch.png'
import Bina from './assets/bin.jpg'
import Mid from './assets/middle.jpg'
import Leaf from './assets/leaf.jpg'
import Rem from './assets/Remove.png'
import Sme from './assets/sme.jpg'
import Lm from './assets/Lm.jpg'
import Mir from './assets/mir.png'
import Iden from './assets/iden.png'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
 
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Rev} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse a Linked List in groups of given size</p>
      <NavLink to='/category/Microsoft Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Bin} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Is Binary Number Multiple of 3</p>
        <NavLink to='/category/Microsoft Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Algo} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Kadane’s Algorithm</p>
      <NavLink to='/category/Microsoft Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Mis} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Missing number in array</p>
      <NavLink to='/category/Microsoft Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Maj} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Majority Element</p>
      <NavLink to='/category/Microsoft Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Search} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Search in a Rotated Array</p>
        <NavLink to='/category/Microsoft Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Bina} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Check for BST</p>
      <NavLink to='/category/Microsoft Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Mid} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Finding middle element in a linked list</p>
      <NavLink to='/category/Microsoft Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Leaf} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Root to leaf path sum</p>
      <NavLink to='/category/Microsoft Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Rev} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse a linked list</p>
        <NavLink to='/category/Microsoft Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Rem} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Remove every k’th node</p>
      <NavLink to='/category/Microsoft Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Rev} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Merge 2 sorted linked list in reverse order</p>
      <NavLink to='/category/Microsoft Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Sme} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Longest Even Length Substring such that Sum of First and Second Half is same</p>
      <NavLink to='/category/Microsoft Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Lm} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>k largest(or smallest) elements in an array | added Min Heap method</p>
        <NavLink to='/category/Microsoft Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Mir} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Write an Efficient Function to Convert a Binary Tree into its Mirror Tree</p>
      <NavLink to='/category/Microsoft Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Iden} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Determine if Two Trees are Identical</p>
      <NavLink to='/category/Microsoft Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    </div>
        </div>
    )
}

export default Ind

